module.exports = __webpack_public_path__ + "static/media/craftstudio.b237a038.png";